import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import InkTabBarNode from './InkTabBarNode';
import TabBarTabsNode from './TabBarTabsNode';
import TabBarRootNode from './TabBarRootNode';
import ScrollableTabBarNode from './ScrollableTabBarNode';
import SaveRef from './SaveRef';
var ScrollableInkTabBar = function (_React$Component) {
  _inherits(ScrollableInkTabBar, _React$Component);
  function ScrollableInkTabBar() {
    _classCallCheck(this, ScrollableInkTabBar);
    return _possibleConstructorReturn(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
  }
  _createClass(ScrollableInkTabBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      return React.createElement(SaveRef, null, function (saveRef, getRef) {
        return React.createElement(TabBarRootNode, _extends({
          saveRef: saveRef
        }, _this2.props), React.createElement(ScrollableTabBarNode, _extends({
          saveRef: saveRef,
          getRef: getRef
        }, _this2.props), React.createElement(TabBarTabsNode, _extends({
          saveRef: saveRef
        }, _this2.props)), React.createElement(InkTabBarNode, _extends({
          saveRef: saveRef,
          getRef: getRef
        }, _this2.props))));
      });
    }
  }]);
  return ScrollableInkTabBar;
}(React.Component);
export default ScrollableInkTabBar;